import * as Yup from 'yup';
import { DB_PREFIX } from './constants';

export default Yup.object().shape({
  [DB_PREFIX]: Yup.object().shape({
    title: Yup.string(),
    firstName: Yup.string().required('Please input your first name'),
    lastName: Yup.string().required('Please input your last name'),
    mobilePhone: Yup.string().required('Please input your phone number'),
  }),
});
